import type { ReactNode } from "react";
import { Input } from "@corpuscomplete/web-ui/components/input";
import { Button } from "@corpuscomplete/web-ui/components/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@corpuscomplete/web-ui/components/dropdown-menu";
import { MoreHorizontalIcon } from "lucide-react";

export function SlotEditor({
  name,
  time,
  onChangeName,
  onChangeTime,
  targetsControl,
  onRemove,
}: {
  name: string;
  time: string;
  onChangeName: (name: string) => void;
  onChangeTime: (time: string) => void;
  targetsControl: ReactNode;
  onRemove: () => void;
}) {
  return (
    <div className="flex flex-col px-1">
      <Input
        value={name}
        variant="ghost"
        textVariant="h3"
        onChange={(event) => onChangeName(event.target.value)}
        placeholder="Slot name"
      />
      <div className="flex flex-wrap items-center gap-0.5">
        <Input
          type="time"
          value={toTimeInput(time)}
          variant="ghost"
          textVariant="sm"
          onChange={(event) => onChangeTime(event.target.value)}
          className="w-fit text-muted-foreground"
        />
        {targetsControl}
        <DropdownMenu>
          <DropdownMenuTrigger
            render={<Button variant="ghost" size="icon-sm" className="shrink-0" />}
          >
            <MoreHorizontalIcon className="size-3.5" />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem variant="destructive" onClick={onRemove}>
              Remove Slot
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
}

function toTimeInput(value: string): string {
  const parts = value.split(":");
  if (parts.length >= 2) {
    return `${parts[0] ?? "00"}:${parts[1] ?? "00"}`;
  }
  return value;
}
